import React, { useState } from "react";
import HeaderDashboard from "./HeaderDashboard";
import SidebarDashboard from "./SidebarDashboard";
import { useNavigate } from "react-router-dom";

const HeaderApp = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false); 
  const navigate = useNavigate();

  const handleMenuClick = () => {
    setSidebarOpen(true); 
  };

  const handleOptionClick = (value) => {
    console.log("Opción seleccionada:", value);
    navigate(value)
    setSidebarOpen(false); 
  };

  return (
    <>
      <HeaderDashboard onMenuClick={handleMenuClick} />
      <SidebarDashboard
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onOptionClick={handleOptionClick}
      />
    </>
  );
};

export default HeaderApp;
